import { computed, type Ref, ref, watch } from "vue";
import { generate as generateLuhn } from 'luhn-js'
import {
  isValidBarcodeInRanges,
  isValidEan8InRange,
  isValidLuhnInRange,
  barcodeCheckSum,
  getMasksFromConfig,
  getPrefixesFromConfig,
} from '@/utils/barcode';

import type { BarcodesRange } from '@/utils/barcode';

export default function useBarcode(config: { ranges: BarcodesRange[] }) {
  const barcode: Ref<string>  = ref("");
  const mask = ref((value: string) => '');
  // const mask = ref('');
  const isValid: Ref<boolean> = ref(isValidBarcodeInRanges(barcode.value, config.ranges));

  const prefix = getPrefixesFromConfig(config.ranges);

  const setPrefix = () => {
    if(!barcode.value || barcode.value === '') {
      barcode.value = prefix;
    }
  }

  mask.value = getMasksFromConfig(config.ranges);

  const isInvalid  = computed(() => {
    return (config?.ranges.length === 0) ? false : !isValid.value;
  })

  watch(barcode, (value) => {
    if (!value || value === '') {
      isValid.value = false;
      return;
    }

    isValid.value = isValidBarcodeInRanges(value, config.ranges)

    if (!isValid.value){
      config.ranges.forEach(function (range: BarcodesRange) {
        if (range.type === 'EAN-8' && isValidEan8InRange(value, range)) {
          barcode.value += barcodeCheckSum(value);
        }
        if (range.type === 'LUHN' && isValidLuhnInRange(value, range)) {
          barcode.value = generateLuhn(value)
        }
      })
    }
  })

  return {
    barcode,
    isValid,
    isInvalid,
    mask,
    setPrefix,
  }
}